import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import SearchForAuditActionsSystem from "../../../components/administration/auditActionsSystem/searchForAuditActionsSystem/SearchForAuditActionsSystem";
import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";
import UserHistoryButton from "../../../components/AdministrativeProcedures/commonComponents/UserHistoryButton/UserHistoryButton";

import {
  getDataAuditActionsSystem,
  getUserHistory,
} from "../../../redux/auditActionsSystemReducer/actionAuditActionsSystem";

import {
  getInputsAuditActionsSystem,
  serInputsAuditActionsSystem,
} from "../../../components/administration/auditActionsSystem/searchForAuditActionsSystem/optionsSearchAuditActionsSystem";

import { AUDIT_ACTIONS_SYSTEM } from "../../../components/GeneralComponents/SearchTable/TablesColumns";

import styles from "./auditActionsSystem.module.css";

function AuditActionsSystem() {
  const dispatch = useDispatch();

  const [directoryLoad, setDirectoryLoad] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchData, setSearchData] = useState({
    fio: "",
    logDocNum: "",
    startDate: "",
    endDate: "",
  });

  const { data, userHistory } = useSelector(
    (state) => state.auditActionSystemReducer
  );
  const allAuditObject = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allAuditObject.map((item) => {
      return {
        value: item.id,
        label: item.name,
        key: "objectId",
      };
    });
  });

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = useCallback((pageIndex) => {
    setSelectedPage(pageIndex);
  }, []);

  const getSearchData = (data) => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchData(data);

    dispatch(getDataAuditActionsSystem(data, selectedPage));
  };

  const handleShow = () => {
    dispatch(getUserHistory("user/actions/", selectedRowData?.id));
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(getDataAuditActionsSystem(searchData, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    if (directoryLoad) {
      serInputsAuditActionsSystem("firstInit", allAuditObject);
    }
  }, [directoryLoad]);

  useEffect(() => {
    if (Boolean(allAuditObject.length) && !directoryLoad) {
      setDirectoryLoad(true);
    }
  }, [allAuditObject]);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["component-container"]}>
      <h2 className={styles["component-caption"]}>
        Аудит действий пользователя в системе
      </h2>
      <SearchForAuditActionsSystem
        inputOptions={getInputsAuditActionsSystem()}
        getSearchData={getSearchData}
      />
      <UserHistoryButton
        isDisabled={!selectedRowData?.id}
        handleShow={handleShow}
        userHistory={userHistory}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={AUDIT_ACTIONS_SYSTEM}
        data={data.content || []}
        totalPages={data.totalPages || 0}
        totalElements={data.totalElements || 0}
        selectedPage={selectedPage}
      />
    </div>
  );
}

export default AuditActionsSystem;
